export const PLACEMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const OVERFLOW_SIDE = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const CONTENT_OFFSET = 4;
export const PAGE_PADDING = 16;

export const ANIMATION_TIMEOUT = 300;

// позволяет избежать случайного появления тултипа при быстром проходе курсора через триггер
export const ACCIDENTAL_TRIGGER_TIMEOUT = 100;

// Дает возможность перевести курсор с триггера на плашку контента,
// не давая при этом плашке исчезнуть.
// Может быть полезно, если нужно скопировать текст с плашки контента
export const HOVER_LEAVE_TIMEOUT = 300;
